/*
 * @Author: wsx
 * @Date: 2022-01-17 11:47:52
 * @LastEditTime: 2022-01-21 15:51:39
 * @LastEditors: your name
 * @Description:mix
 */
export default function mix(...mixins) {
  class Mix {
    constructor(options) {
      for (const Mixin of mixins) {
        copyProperties(this, new Mixin(options)); // 拷贝实例属性
      }
    }
  }

  for (const mixin of mixins) {
    copyProperties(Mix, mixin); // 拷贝静态属性
    copyProperties(Mix.prototype, mixin.prototype); // 拷贝原型属性
  }

  return Mix;
}

function copyProperties(target, source) {
  for (const key of Reflect.ownKeys(source)) {
    if (key !== "constructor" && key !== "prototype" && key !== "name") {
      const desc = Object.getOwnPropertyDescriptor(source, key);
      Object.defineProperty(target, key, desc);
    }
  }
}
